export default __webpack_public_path__ + "static/media/plan4-col3-img.37dd1aef.svg";